import { render, staticRenderFns } from "./Floricultura.vue?vue&type=template&id=f18b3e8c"
import script from "./Floricultura.vue?vue&type=script&lang=js"
export * from "./Floricultura.vue?vue&type=script&lang=js"
import style0 from "./Floricultura.vue?vue&type=style&index=0&id=f18b3e8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports